import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  it: {
    translation: {
      common: {
        create: 'Crea',
        save: 'Salva',
        cancel: 'Annulla',
        search: 'Cerca',
        loading: 'Caricamento…'
      },
      navigation: {
        dashboard: 'Panoramica',
        clients: 'Clienti',
        crm: 'CRM',
        projects: 'Progetti',
        notes: 'Note',
        tasks: 'Attività',
        time: 'Tempo',
        billing: 'Scadenze',
        expenses: 'Spese',
        settings: 'Impostazioni'
      }
    }
  },
  en: {
    translation: {
      common: {
        create: 'Create',
        save: 'Save',
        cancel: 'Cancel',
        search: 'Search',
        loading: 'Loading…'
      },
      navigation: {
        dashboard: 'Overview',
        clients: 'Clients',
        crm: 'CRM',
        projects: 'Projects',
        notes: 'Notes',
        tasks: 'Tasks',
        time: 'Time',
        billing: 'Billing',
        expenses: 'Expenses',
        settings: 'Settings'
      }
    }
  }
} as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: 'it',
  fallbackLng: 'it',
  interpolation: { escapeValue: false }
});

export default i18n;
